import React, { FC } from 'react';
import cn from 'classnames';

const sharedParagraphClassnames = ' before:-ml-4 before:text-astronautBlue-500';

const Check: FC = () => {
  return (
    <div>
      <p className="mb-1">
        Після закінчення інтеграції необхідно перевірити всі базові сценарії:
      </p>
      <ul className="ml-6">
        <li>
          <span
            className={cn("before:content-['1.']", sharedParagraphClassnames)}
          >
            Кліент стоворив замовлення, аптека його не опрацювала, ви отримали
            статус про скасування замовлення по таймінгу
          </span>
        </li>
        <li>
          <span
            className={cn("before:content-['2.']", sharedParagraphClassnames)}
          >
            Кліент стоворив замовлення, аптека його опрацювала але потім кліент
            скасував замовлення в аптеці
          </span>
        </li>
        <li>
          <span
            className={cn("before:content-['3.']", sharedParagraphClassnames)}
          >
            Кліент стоворив замовлення, аптека його опрацювала, але потім кліент
            скасував замовлення в персональному кабінеті, ви отримали статус про
            скасування замовлення
          </span>
        </li>
        <li>
          <span
            className={cn("before:content-['4.']", sharedParagraphClassnames)}
          >
            Кліент стоворив замовлення, аптека його опрацювала та клієнт забрав
            замовлення
          </span>
        </li>
      </ul>
    </div>
  );
};

export default Check;
